export default [
  {
    path: '/aplikasiku',
    alias: '/setting/apps',
    name: 'aplikasiku',
    component: () => import('@/views/pages/komship/myapps/MyApps.vue'),
    meta: {
      name: 'aplikasiku',
      resource: 'MyApps',
      action: 'manage',
    },
  },
]
